"use client";

import Link from "next/link";
import type { ComponentProps } from "react";

import {
  trackBlogCtaClicked,
  trackSeoLandingCtaClicked,
} from "@/lib/posthog-client";

type LinkProps = ComponentProps<typeof Link>;

export function SeoLandingCtaLink({
  slug,
  label,
  location,
  ...props
}: LinkProps & {
  slug: string;
  label: string;
  location: "hero" | "final";
}) {
  return (
    <Link
      {...props}
      onClick={(event) => {
        props.onClick?.(event);
        trackSeoLandingCtaClicked({ slug, label, location });
      }}
    />
  );
}

export function BlogCtaLink({
  slug,
  location,
  ...props
}: LinkProps & {
  slug: string;
  location: "article_bottom";
}) {
  return (
    <Link
      {...props}
      onClick={(event) => {
        props.onClick?.(event);
        trackBlogCtaClicked({ slug, location });
      }}
    />
  );
}
